export const footerData = [
  {
    id: 'p1',
    title: 'service',
    items: [
      {
        id: 'p1c1',
        name: 'aha_delivery',
        href: '/service/aha-delivery',
        external: false,
      },
      {
        id: 'p1c2',
        name: 'ev_rental',
        href: `${process.env.NEXT_PUBLIC_APP_URI}`,
        external: false,
      },
      {
        id: 'p1c3',
        name: 'aha_truck',
        href: '/service/aha-truck',
        external: false,
      },
      {
        id: 'p1c4',
        name: 'corperate_service',
        href: '/service/cooperate',
        external: false,
      },
    ],
  },
  {
    id: 'p2',
    title: 'about',
    items: [
      {
        id: 'p2c1',
        name: 'about_us',
        href: '/about-us',
        external: false,
      },
      {
        id: 'p2c2',
        name: 'news',
        href: '/blog',
        external: false,
      },
      {
        id: 'p2c3',
        name: 'recruitment',
        href: '/recruitment',
        external: false,
      },
    ],
  },
  {
    id: 'p3',
    title: 'customer',
    items: [
      {
        id: 'p3c1',
        name: 'individual',
        href: '/customer/merchant',
        external: false,
      },
      {
        id: 'p3c2',
        name: 'corporate',
        href: '/customer/cooperate',
        external: false,
      },
      {
        id: 'p3c3',
        name: 'customer_community',
        href: '',
        external: false,
      },
      {
        id: 'p3c4',
        name: 'customer_help_center',
        href: '/customer/help-center',
        external: false,
      },
      {
        id: 'p4c5',
        name: 'integration_account',
        href: '/intergration-account',
        external: false,
      },
    ],
  },
  {
    id: 'p4',
    title: 'support',
    items: [
      {
        id: 'p4c1',
        name: 'terms_and_policies',
        href: '/policy',
        external: false,
      },
    ],
  },
  {
    id: 'p5',
    title: 'driver',
    items: [
      {
        id: 'p5c1',
        name: 'registration',
        href: '/driver',
        external: false,
      },
      {
        id: 'p5c2',
        name: 'driver_community',
        href: '/blog?category=shippers',
        external: false,
      },
      {
        id: 'p5c3',
        name: 'driver_handbook',
        href: '/driver/handbook',
        external: false,
      },
      {
        id: 'p5c4',
        name: 'driver_help_center',
        href: '/driver/help-center',
        external: false,
      },
    ],
  },
  {
    id: 'p6',
    title: 'quick_access',
    items: [
      {
        id: 'p6c1',
        name: 'customer_help_center',
        href: '/customer/help-center',
        external: false,
      },
      {
        id: 'p6c2',
        name: 'driver_help_center',
        href: '/driver/help-center',
        external: false,
      },
      {
        id: 'p6c3',
        name: 'developer_portal',
        external: true,
        href: 'https://developers.ahamove.com',
      },
    ],
  },
];
